import { NotFoundProperty } from "../Icon";
import DefaultPageComponent from "./DefaultPageComponent";

const NoSearchCriteria = () => {
  return (
    <DefaultPageComponent
      image="/images/not-found-optimize.gif"
      className="!pt-0-mt-12"
      append={
        <div className=" w-full  text-disabled-main text-left">
          <h2 className=" font-semibold mb-4">No Results Found</h2>
          <p className="mb-6">
            We couldn’t find any listings that match your search.
          </p>

          <h3 className="font-semibold text-2xl mb-2">
            Why This Might Happen:
          </h3>
          <ul className="list-disc list-inside mb-6 space-y-1">
            <li>
              Your search terms may not match any properties currently
              available.
            </li>
            <li>
              The property or service you are looking for might not be listed on
              our platform yet.
            </li>
            <li>There could be a typo or small error in your search query.</li>
          </ul>

          <h3 className="font-semibold text-2xl mb-2">
            Tips to Help You Find What You Need:
          </h3>
          <ul className="list-disc list-inside space-y-1 mb-6">
            <li>
              <strong>Double-check your spelling</strong> to ensure there are no
              errors.
            </li>
            <li>
              <strong>Try broader keywords</strong> — for example, search by
              city instead of neighborhood.
            </li>
            <li>
              <strong>Use fewer words</strong> for a simpler, more flexible
              search.
            </li>
            <li>
              <strong>Review your filters</strong> and adjust them to see more
              options.
            </li>
            <li>
              <strong>Search again</strong> with different terms or related
              keywords.
            </li>
          </ul>

          <p>
            Still can’t find what you’re looking for? Our support team is here
            to help!
          </p>
        </div>
      }
      text={``}
      svg={NotFoundProperty}
    />
  );
};
export default NoSearchCriteria;
